import i18n from 'services/base/i18n';

export default {
  address: () => i18n.pgettext('Components|List History|Filter History|Site Input|Network Input', 'Network IP'),
  mask:    () => i18n.pgettext('Components|List History|Filter History|Site Input|Network Input', 'Mask'),
};
